import { render, staticRenderFns } from "./AdminUserEdit.vue?vue&type=template&id=4b142ce6&"
import script from "./AdminUserEdit.vue?vue&type=script&lang=ts&"
export * from "./AdminUserEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports